<template>
  <tr >
        <td class="v-align-middle">
            {{offer.distributed_product.agency.name}}
        </td>

        <td class="v-align-middle">
            {{ offer.name }}
        </td>

        <td class="v-align-middle" v-if="offer.default_price">
            {{offer.default_price.base_price / 100 }} {{offer.default_price.currency}} / {{offer.default_price.unit_text}}
        </td>

        <td class="v-align-middle" v-else>
          <input v-if="!updaterDataFromCart" class="col-lg-6" type="number" min="0.01" step="0.01" name="price" v-model="price_specified_by_user">
          <p v-else-if="retreiveDataFromCart" >
            {{ this.getprice }}
          </p>
          <p>EUR / par mois</p>
        </td>

         <td class="v-align-middle" v-if="offer.default_price">
            {{offer.default_price.base_quantity}}
         </td>

        <td class="v-align-middle" v-else>
           1
        </td>

        <!-- <td> -->

          <!-- <input type="date" v-model="start_date_available">
          </input>

          <input type="date" v-model="end_date_available">
          </input> -->

        <!-- </td> -->

      <td class="v-align-middle">
        <div v-if="!offer.distributed_product.agency.disabled_for_tup">
          <button v-if="notincart(this.myoffer) && this.mayupdate.length > 0" class="btn btn-danger"
            @click="$emit('crushcart', offerReady)">
            Offre incompatible avec le contenu du panier
          </button>

          <button class="btn btn-warning" v-else-if="cartCheck(this.myoffer) && this.mayupdate.length > 0">
              Offre déjà présente dans le panier
          </button>

          <button class="btn btn-complete" @click="$emit('add', offerReady)" v-else>
            <i class="fa fa-cart-arrow-down" aria-hidden="true">
            </i>
            Ajouter au panier
          </button>
        </div>
      </td>
  </tr>
</template>

<script>

export default {

  data: function() {
    return {
      price_specified_by_user:0,
      start_date_available:null,
      end_date_available:null,
      currency:"EUR",
    };
  },

  props: {
    offer: {
      required: true,
      type: Object
    },
    mayupdate: {
      required:true
    }
  },

  computed: {
    offerReady: function ()
    {
      if (this.offer.default_price)
        return {
                  offer:this.offer,
                  price:this.offer.default_price.base_price,
                  quantity:1,
                  unit:"MOS",
                  // booking_start_date_required:this.start_date_available,
                  // booking_end_date_required:this.end_date_available,
                  free_price:0
                }
      else
        return {
                  offer:this.offer,
                  price:this.price_specified_by_user,
                  unit:"MOS",
                  quantity:1,
                  // booking_start_date_required:this.start_date_available,
                  // booking_end_date_required:this.end_date_available,
                  free_price:1
                }
    },
    myoffer:function(){
      return this.offer
    },
    getprice:function(){
      return this.price_specified_by_user
    },

    updaterDataFromCart: function () {
      const offer_id = this.myoffer.id
      const data = this.mayupdate.filter(
        function (item) {
          return (item.id == offer_id)
        }
      )
      if (data.length == 0)
      {
        return false
      }
      else {
        return true
      }
    },

    retreiveDataFromCart:function () {
      const offer_id = this.myoffer.id
      const data = this.mayupdate.filter(
        function (item) {
          return (item.id == offer_id)
        }
      )
      if (data.length == 0)
      {
        return false
      }
      else {
        if (this.myoffer.default_price == null)
        {
          this.price_specified_by_user = data[0].price
          this.quantity_specified_by_user = data[0].quantity
        }
        return true
      }
    }

  },

  methods:
  {
    notincart:function (offer)
    {
      const res =
        !this.mayupdate.find (
            function (item) {
                // console.log(item.id + " " + offer.id)
                return item.id == offer.id
            })
      // console.log(offer.id + " IS IN CART " + res)
      return (res)
    },

    compatibleWithCartContent:function (offer)
    {
      const res = this.mayupdate.find (
        function (item)
        {
          return item.distribution_method_id != 2
        }
      )
      if (res == undefined)
        return true
      else {return false}
    },

    cartCheck:function(offer)
    {
      const others = this.mayupdate.filter(
        function(item) {return item.distribution_method_id != 2}
      )
      if (others.length == 0)
        return true
      else {
          return false
        }
    }

  }

}

</script>

<style>
</style>



// WEBPACK FOOTER //
// client/components/Catalog/CatalogLldItem.vue